/* eslint-disable */
import { createStyles, makeStyles } from "@material-ui/core";
import type { Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: { 
      fontSize: '26px',
      fontWeight: 600,
      lineHeight: 1.4,
      paddingBottom: 2,
      borderBottom: `solid 1px ${theme.palette.common.black}`,
    },
    body: {
      paddingTop: 5,
      fontSize: '16px',
      lineHeight: 1.5,
    },
    linkPrivacyStatement: {
      cursor: 'pointer',
    }
  })
);
